<template>
  <div class="main">
	<div class="phindex" v-if="type == 'h5'">
		<div class="phindex-hea">
			<div class="phinhea-top">Welcome to Visit GUILIN WOODPECKER MEDICAL INSTRUMENT CO.,LTD. Website!</div>
			<!-- <div class="phinhea-foo">啄木鸟医疗器械有限公司官方网站！</div> -->
		</div>
		<phindex :content="list" @jump="todetails"></phindex>
	</div>

	<div class="pcindedxc" v-if="type == 'pc'">
		<div class="pcindexc-header">
			Welcome to Visit GUILIN WOODPECKER MEDICAL INSTRUMENT CO.,LTD. Website!
		</div>
		<pcindex :content="list" @jump="todetails"></pcindex>
	</div>
  </div>
</template>

<script>

import  'lib-flexible/flexible.js'
import {session} from '../storage/storage.js';
import phindex from "../common/phindex1.vue"
import pcindex from "../common/Pcindex.vue"
export default {
	data(){
		return {
			type:"",
			list:[]
		}
	},
	components:{pcindex,phindex},
	created(){


		if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
			this.type = 'h5'
			this.ress()
		}else{
			this.type = 'pc'
		}
		
		// if(!!this.$route.query.page){
		// 	this.$router.push({path:this.$route.query.page,e:this.$route.query.e})
		// 	return
		// }

		console.log(this.type)
		this.getIndexData();
	},
	mounted(){
		
	},
	methods:{
		getIndexData(){
			this.$api.pcindex({mold:this.type,lang:'en'}).then((res) => {
				this.list = res.data
			});
		},
		todetails(channel_id){
			//品牌id存入缓存中
			session.set("channel_id",channel_id);
			session.set("lang",'en');
			if(this.type == 'h5'){
				this.$router.push({path: '/pchome'});
			}else if(this.type == 'pc'){
				this.$router.push({path: '/phhome'});
			}
		},
		ress(){
			console.log('resssss1111111111111111')
			var html = document.documentElement; //获取根元素
			var designWidth = 750; //设计稿宽度
			//html.clientWidth 视口宽度
			html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
		},
	}
}
</script>
<style>
.phindex{
		width: 7.5rem;
		height: 100vh;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		
	}
	.phindex-hea{
		
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-bottom: 0.6rem;
	}
	.phinhea-top{
		font-size: 0.32rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-bottom: 0.2rem;
		text-align: center;
	}
	.phinhea-foo{
		font-size: 0.32rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
	}
	.phindexc-content{
		width: 7.5rem;
		display: flex;
		flex-wrap: wrap;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.phindexc-content img{
		width: 4.6rem;
		height: 2.2rem;
	}
	.pcindedxc{
		width: calc(100vw - 50px);
		height: calc(100vh - 50px);
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	
	.pcindexc-content{
		display: flex;
		flex-wrap: wrap;
		width: 960px;
	}
	.pcindexc-header{
		height: 45px;
		font-size: 32px;
		font-weight: 400;
		color: #5d5f5f;
		line-height: 45px;
		letter-spacing: 1px;
	}
</style>